export default __webpack_public_path__ + "static/media/xpeedstudio-js-demo.a46bda28.webp";